import { render, staticRenderFns } from "./FormTab.vue?vue&type=template&id=4e30bfe9&"
import script from "./FormTab.vue?vue&type=script&lang=js&"
export * from "./FormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports